const BaseModule = require('../../90_utils/base/BaseModule');

class ColorSelector extends BaseModule {

	constructor(el, params) {

		super(el);

		// element vars

		this.$thumbs = this.$el.find('li[data-color]');

		this.$currentColor = null;
		this.$currentColorTitle = this.$el.find('[data-current-color-title]');
	}

	// private methods

	_domReady(){
		super._domReady();
	}

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;

			//

			this.$thumbs.on('mouseenter', this._onThumbOver.bind(this));
			this.$thumbs.on('mouseleave', this._onThumbOut.bind(this));
			this.$thumbs.on('activate', this._onThumbActivate.bind(this));

			this.$currentColor = this.$thumbs.find('.is-active');

			if(this.$currentColor.length){
				this._changeColorByThumb(this.$currentColor);
			}
			else {
				this.$currentColor = this.$thumbs.eq(0);
				this._changeColorByThumb(this.$thumbs.eq(0));
			}
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){
			this._isListening = false;
		}

		super._removeListeners();
	}

	// element event listeners

	_onThumbOver(e){
		let $target = $(e.currentTarget);
		this._changeColorByThumb($target);

	}

	_onThumbOut(e){
		this._changeColorByThumb(this.$currentColor);
	}

	_onThumbActivate(e){

		let $target = $(e.currentTarget);

		this.$currentColor = $target;
		this._changeColorByThumb($target);

		this.$el.triggerHandler('select', e);
		this.$el.triggerHandler('activate', e);
	}

	//

	_resize(){

	}

	// change color

	_changeColorByThumb($target){

		let color = $target.attr('data-color-title');
		this.$currentColorTitle.html(color);
	}
}

module.exports = ColorSelector;
